import { type FormikErrors } from 'formik';

import { type CostCenter } from 'modules/company/cost-centers/costCenter';
import { type TGlobalFunctionTyped } from 'src/core/common/hooks/useTranslation';

import type { FormValues } from './CostCenterDetailsContent';

type FormErrors = FormikErrors<FormValues>;

const hasCostCenterWithSameName = (
  name: string | undefined,
  costCenterId: string | undefined,
  costCenters: CostCenter[],
): boolean => {
  return costCenters.some(
    (costCenter) =>
      costCenter.id !== costCenterId &&
      costCenter.name.toLowerCase() === name?.toLowerCase(),
  );
};

export const validateCostCenterForm = (
  values: FormValues,
  translator: TGlobalFunctionTyped,
  costCenterId: string | undefined,
  costCenters: CostCenter[],
): FormErrors => {
  const errors: FormErrors = {};

  // Validate cost center name of the same company
  if (hasCostCenterWithSameName(values.name, costCenterId, costCenters)) {
    errors.name = translator('costCenters.form.errors.nameAlreadyExists', {
      name: values.name,
    });
  }

  if (!values.name || values.name?.trim() === '') {
    errors.name = translator('costCenters.form.errors.nameEmpty');
  }

  if (!values.ownerId) {
    errors.ownerId = translator('costCenters.form.errors.ownerEmpty');
  }

  return errors;
};
